import { startCase } from 'lodash';
import { fmtPrice } from './formatter';

const PRICE_PROPERTIES = [
  'displayPrice',
  'effectivePrice',
  'taxAmount',
  'monthly',
  'fees',
  'downPayment',
  'financeAmount',
  'assetValue',
  'netTrade',
];

const NAME_TO_DISPLAYNAME_MAP: Record<string, string> = {
  months: 'Terms',
  effectivePrice: 'Vehicle Sales Price',
};

// applies currency format to a specific set of FinanceResponse property values
export const formatPropValue = (
  propertyName: string,
  value: string | number | boolean | null | undefined,
): string => {
  if (
    (typeof value === 'number' || typeof value === 'string') &&
    PRICE_PROPERTIES.includes(propertyName)
  ) {
    return fmtPrice(value);
  }
  return `${value}`;
};

export const formatPropName = (name: string) => {
  if (NAME_TO_DISPLAYNAME_MAP[name]) {
    return NAME_TO_DISPLAYNAME_MAP[name];
  }
  return startCase(name);
};
